import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "button is-text p-0"
}

import { useAppStore } from '@/popup/store/AppStore'
import SvgIcon from './SvgIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkIcon',
  setup(__props) {

const appStore = useAppStore()

return (_ctx: any,_cache: any) => {
  return (_unref(appStore).network.id)
    ? (_openBlock(), _createElementBlock("button", _hoisted_1, [
        (_unref(appStore).network.id === 'mainnet')
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              name: "lukso-icon",
              color: "#FE005B",
              width: "22",
              height: "22"
            }))
          : _createCommentVNode("v-if", true),
        (_unref(appStore).network.id === 'testnet')
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 1,
              name: "lukso-icon",
              color: "#FFB84C",
              width: "22",
              height: "22"
            }))
          : _createCommentVNode("v-if", true),
        (_unref(appStore).network.id === 'ethereum-sepolia')
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 2,
              name: "ethereum-sepolia-icon",
              width: "22",
              height: "22"
            }))
          : _createCommentVNode("v-if", true),
        (_unref(appStore).network.id === 'ethereum-mainnet')
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 3,
              name: "ethereum-icon",
              width: "22",
              height: "22"
            }))
          : _createCommentVNode("v-if", true),
        (_unref(appStore).network.id === 'base-sepolia')
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 4,
              name: "base-icon",
              color: "#0A0B0D",
              width: "22",
              height: "22"
            }))
          : _createCommentVNode("v-if", true),
        (_unref(appStore).network.id === 'base-mainnet')
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 5,
              name: "base-icon",
              color: "#0052FF",
              width: "22",
              height: "22"
            }))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})